import {
  PropertyType,
  SubscriptionType,
  SupportedCheckInAndOutTimes,
  UniquePropertyType,
} from '@gql';

export const stringToEnumSupportedCheckInAndOutTimes = (
  time: string
): SupportedCheckInAndOutTimes => {
  switch (time) {
    case 'AM0100':
      return SupportedCheckInAndOutTimes.Am0100;
    case 'AM0130':
      return SupportedCheckInAndOutTimes.Am0130;
    case 'AM0200':
      return SupportedCheckInAndOutTimes.Am0200;
    case 'AM0230':
      return SupportedCheckInAndOutTimes.Am0230;
    case 'AM0300':
      return SupportedCheckInAndOutTimes.Am0300;
    case 'AM0330':
      return SupportedCheckInAndOutTimes.Am0330;
    case 'AM0400':
      return SupportedCheckInAndOutTimes.Am0400;
    case 'AM0430':
      return SupportedCheckInAndOutTimes.Am0430;
    case 'AM0500':
      return SupportedCheckInAndOutTimes.Am0500;
    case 'AM0530':
      return SupportedCheckInAndOutTimes.Am0530;
    case 'AM0600':
      return SupportedCheckInAndOutTimes.Am0600;
    case 'AM0630':
      return SupportedCheckInAndOutTimes.Am0630;
    case 'AM0700':
      return SupportedCheckInAndOutTimes.Am0700;
    case 'AM0730':
      return SupportedCheckInAndOutTimes.Am0730;
    case 'AM0800':
      return SupportedCheckInAndOutTimes.Am0800;
    case 'AM0830':
      return SupportedCheckInAndOutTimes.Am0830;
    case 'AM0900':
      return SupportedCheckInAndOutTimes.Am0900;
    case 'AM0930':
      return SupportedCheckInAndOutTimes.Am0930;
    case 'AM1000':
      return SupportedCheckInAndOutTimes.Am1000;
    case 'AM1030':
      return SupportedCheckInAndOutTimes.Am1030;
    case 'AM1100':
      return SupportedCheckInAndOutTimes.Am1100;
    case 'AM1130':
      return SupportedCheckInAndOutTimes.Am1130;
    case 'AM1200':
      return SupportedCheckInAndOutTimes.Am1200;
    case 'AM1230':
      return SupportedCheckInAndOutTimes.Am1230;
    case 'FLEXIBLE':
      return SupportedCheckInAndOutTimes.Flexible;
    case 'PM0100':
      return SupportedCheckInAndOutTimes.Pm0100;
    case 'PM0130':
      return SupportedCheckInAndOutTimes.Pm0130;
    case 'PM0200':
      return SupportedCheckInAndOutTimes.Pm0200;
    case 'PM0230':
      return SupportedCheckInAndOutTimes.Pm0230;
    case 'PM0300':
      return SupportedCheckInAndOutTimes.Pm0300;
    case 'PM0330':
      return SupportedCheckInAndOutTimes.Pm0330;
    case 'PM0400':
      return SupportedCheckInAndOutTimes.Pm0400;
    case 'PM0430':
      return SupportedCheckInAndOutTimes.Pm0430;
    case 'PM0500':
      return SupportedCheckInAndOutTimes.Pm0500;
    case 'PM0530':
      return SupportedCheckInAndOutTimes.Pm0530;
    case 'PM0600':
      return SupportedCheckInAndOutTimes.Pm0600;
    case 'PM0630':
      return SupportedCheckInAndOutTimes.Pm0630;
    case 'PM0700':
      return SupportedCheckInAndOutTimes.Pm0700;
    case 'PM0730':
      return SupportedCheckInAndOutTimes.Pm0730;
    case 'PM0800':
      return SupportedCheckInAndOutTimes.Pm0800;
    case 'PM0830':
      return SupportedCheckInAndOutTimes.Pm0830;
    case 'PM0900':
      return SupportedCheckInAndOutTimes.Pm0900;
    case 'PM0930':
      return SupportedCheckInAndOutTimes.Pm0930;
    case 'PM1000':
      return SupportedCheckInAndOutTimes.Pm1000;
    case 'PM1030':
      return SupportedCheckInAndOutTimes.Pm1030;
    case 'PM1100':
      return SupportedCheckInAndOutTimes.Pm1100;
    case 'PM1130':
      return SupportedCheckInAndOutTimes.Pm1130;
    case 'PM1200':
      return SupportedCheckInAndOutTimes.Pm1200;
    case 'PM1230':
      return SupportedCheckInAndOutTimes.Pm1230;
    default:
      throw new Error('Unsupported SupportedCheckInAndOutTime');
  }
};

export const enumSupportedCheckInAndOutTimesToString = (
  time: SupportedCheckInAndOutTimes
): string => {
  switch (time) {
    case SupportedCheckInAndOutTimes.Am0100:
      return '01:00 AM';
    case SupportedCheckInAndOutTimes.Am0130:
      return '01:30 AM';
    case SupportedCheckInAndOutTimes.Am0200:
      return '02:00 AM';
    case SupportedCheckInAndOutTimes.Am0230:
      return '02:30 AM';
    case SupportedCheckInAndOutTimes.Am0300:
      return '03:00 AM';
    case SupportedCheckInAndOutTimes.Am0330:
      return '03:30 AM';
    case SupportedCheckInAndOutTimes.Am0400:
      return '04:00 AM';
    case SupportedCheckInAndOutTimes.Am0430:
      return '04:30 AM';
    case SupportedCheckInAndOutTimes.Am0500:
      return '05:00 AM';
    case SupportedCheckInAndOutTimes.Am0530:
      return '05:30 AM';
    case SupportedCheckInAndOutTimes.Am0600:
      return '06:00 AM';
    case SupportedCheckInAndOutTimes.Am0630:
      return '06:30 AM';
    case SupportedCheckInAndOutTimes.Am0700:
      return '07:00 AM';
    case SupportedCheckInAndOutTimes.Am0730:
      return '07:30 AM';
    case SupportedCheckInAndOutTimes.Am0800:
      return '08:00 AM';
    case SupportedCheckInAndOutTimes.Am0830:
      return '08:30 AM';
    case SupportedCheckInAndOutTimes.Am0900:
      return '09:00 AM';
    case SupportedCheckInAndOutTimes.Am0930:
      return '09:30 AM';
    case SupportedCheckInAndOutTimes.Am1000:
      return '10:00 AM';
    case SupportedCheckInAndOutTimes.Am1030:
      return '10:30 AM';
    case SupportedCheckInAndOutTimes.Am1100:
      return '11:00 AM';
    case SupportedCheckInAndOutTimes.Am1130:
      return '11:30 AM';
    case SupportedCheckInAndOutTimes.Am1200:
      return '12:00 AM';
    case SupportedCheckInAndOutTimes.Am1230:
      return '12:30 AM';
    case SupportedCheckInAndOutTimes.Flexible:
      return 'Flexible';
    case SupportedCheckInAndOutTimes.Pm0100:
      return '01:00 PM';
    case SupportedCheckInAndOutTimes.Pm0130:
      return '01:30 PM';
    case SupportedCheckInAndOutTimes.Pm0200:
      return '02:00 PM';
    case SupportedCheckInAndOutTimes.Pm0230:
      return '02:30 PM';
    case SupportedCheckInAndOutTimes.Pm0300:
      return '03:00 PM';
    case SupportedCheckInAndOutTimes.Pm0330:
      return '03:30 PM';
    case SupportedCheckInAndOutTimes.Pm0400:
      return '04:00 PM';
    case SupportedCheckInAndOutTimes.Pm0430:
      return '04:30 PM';
    case SupportedCheckInAndOutTimes.Pm0500:
      return '05:00 PM';
    case SupportedCheckInAndOutTimes.Pm0530:
      return '05:30 PM';
    case SupportedCheckInAndOutTimes.Pm0600:
      return '06:00 PM';
    case SupportedCheckInAndOutTimes.Pm0630:
      return '06:30 PM';
    case SupportedCheckInAndOutTimes.Pm0700:
      return '07:00 PM';
    case SupportedCheckInAndOutTimes.Pm0730:
      return '07:30 PM';
    case SupportedCheckInAndOutTimes.Pm0800:
      return '08:00 PM';
    case SupportedCheckInAndOutTimes.Pm0830:
      return '08:30 PM';
    case SupportedCheckInAndOutTimes.Pm0900:
      return '09:00 PM';
    case SupportedCheckInAndOutTimes.Pm0930:
      return '09:30 PM';
    case SupportedCheckInAndOutTimes.Pm1000:
      return '10:00 PM';
    case SupportedCheckInAndOutTimes.Pm1030:
      return '10:30 PM';
    case SupportedCheckInAndOutTimes.Pm1100:
      return '11:00 PM';
    case SupportedCheckInAndOutTimes.Pm1130:
      return '11:30 PM';
    case SupportedCheckInAndOutTimes.Pm1200:
      return '12:00 PM';
    case SupportedCheckInAndOutTimes.Pm1230:
      return '12:30 PM';
  }
};

export const stringToEnumPropertyTypes = (
  propertyType: string
): PropertyType => {
  switch (propertyType) {
    case 'House':
      return PropertyType.House;
    case 'Apartment':
      return PropertyType.Apartment;
    case 'Guest House':
      return PropertyType.GuestHouse;
    case 'Boutique Hotel':
      return PropertyType.BoutiqueHotel;
    case 'Professional Bed and Breakfast':
      return PropertyType.BedAndBreakfast;
    default:
      throw new Error('Unsupported PropertyType');
  }
};

export const enumToStringPropertyTypes = (
  propertyType: PropertyType
): string => {
  switch (propertyType) {
    case PropertyType.House:
      return 'House';
    case PropertyType.Apartment:
      return 'Apartment';
    case PropertyType.GuestHouse:
      return 'Guest House';
    case PropertyType.BoutiqueHotel:
      return 'Boutique Hotel';
    case PropertyType.BedAndBreakfast:
      return 'Professional Bed and Breakfast';
  }
};

export const enumToStringPropertyTypesAbr = (
  propertyType: PropertyType
): string => {
  switch (propertyType) {
    case PropertyType.House:
      return 'House';
    case PropertyType.Apartment:
      return 'Apartment';
    case PropertyType.GuestHouse:
      return 'Guest House';
    case PropertyType.BoutiqueHotel:
      return 'Boutique Hotel';
    case PropertyType.BedAndBreakfast:
      return 'Bed and Breakfast';
  }
};

export const stringToEnumUniquePropertyTypes = (
  uniquePropertyType: string
): UniquePropertyType => {
  switch (uniquePropertyType) {
    case 'Barn':
      return UniquePropertyType.Barn;
    case 'Boat':
      return UniquePropertyType.Boat;
    case 'Boutique Hotel':
      return UniquePropertyType.BoutiqueHotel;
    case 'Bungalow':
      return UniquePropertyType.Bungalow;
    case 'Cabin':
      return UniquePropertyType.Cabin;
    case 'Camper Or Rv':
      return UniquePropertyType.CamperOrRv;
    case 'Campsite':
      return UniquePropertyType.Campsite;
    case 'Casita':
      return UniquePropertyType.Casita;
    case 'Castle':
      return UniquePropertyType.Castle;
    case 'Cave':
      return UniquePropertyType.Cave;
    case 'Chalet':
      return UniquePropertyType.Chalet;
    case 'Cottage':
      return UniquePropertyType.Cottage;
    case 'Condo':
      return UniquePropertyType.Condo;
    case 'Dome House':
      return UniquePropertyType.DomeHouse;
    case 'Earthen Home':
      return UniquePropertyType.EarthenHome;
    case 'Farm Stay':
      return UniquePropertyType.FarmStay;
    case 'Glamping Tent':
      return UniquePropertyType.GlampingTent;
    case 'Historic Hotel':
      return UniquePropertyType.HistoricHotel;
    case 'Home':
      return UniquePropertyType.Home;
    case 'Hostel':
      return UniquePropertyType.Hostel;
    case 'Houseboat':
      return UniquePropertyType.Houseboat;
    case 'Hut':
      return UniquePropertyType.Hut;
    case 'Lighthouse':
      return UniquePropertyType.Lighthouse;
    case 'Nature Lodge':
      return UniquePropertyType.NatureLodge;
    case 'Resort':
      return UniquePropertyType.Resort;
    case 'Rv':
      return UniquePropertyType.Rv;
    case 'Tiny Home':
      return UniquePropertyType.TinyHome;
    case 'Tipi':
      return UniquePropertyType.Tipi;
    case 'Townhouse':
      return UniquePropertyType.Townhouse;
    case 'Treehouse':
      return UniquePropertyType.Treehouse;
    case 'Villa':
      return UniquePropertyType.Villa;
    case 'Windmill':
      return UniquePropertyType.Windmill;
    case 'Yurt':
      return UniquePropertyType.Yurt;
    default:
      throw new Error('Unsupported UniquePropertyType');
  }
};

export const enumToStringUniquePropertyTypes = (
  uniquePropertyType: UniquePropertyType
): string => {
  switch (uniquePropertyType) {
    case UniquePropertyType.Barn:
      return 'Barn';
    case UniquePropertyType.Boat:
      return 'Boat';
    case UniquePropertyType.BoutiqueHotel:
      return 'Guest House';
    case UniquePropertyType.Bungalow:
      return 'Bungalow';
    case UniquePropertyType.Cabin:
      return 'Cabin';
    case UniquePropertyType.CamperOrRv:
      return 'Camper / Rv';
    case UniquePropertyType.Campsite:
      return 'Campsite';
    case UniquePropertyType.Casita:
      return 'Casita';
    case UniquePropertyType.Castle:
      return 'Castle';
    case UniquePropertyType.Cave:
      return 'Cave';
    case UniquePropertyType.Chalet:
      return 'Chalet';
    case UniquePropertyType.Condo:
      return 'Condo';
    case UniquePropertyType.Cottage:
      return 'Cottage';
    case UniquePropertyType.DomeHouse:
      return 'Dome House';
    case UniquePropertyType.EarthenHome:
      return 'Earthen Home';
    case UniquePropertyType.FarmStay:
      return 'Farm Stay';
    case UniquePropertyType.GlampingTent:
      return 'Glamping Tent';
    case UniquePropertyType.HistoricHotel:
      return 'Historic Hotel';
    case UniquePropertyType.Home:
      return 'Home';
    case UniquePropertyType.Hostel:
      return 'Hostel';
    case UniquePropertyType.Houseboat:
      return 'Houseboat';
    case UniquePropertyType.Hut:
      return 'Hut';
    case UniquePropertyType.Lighthouse:
      return 'Lighthouse';
    case UniquePropertyType.NatureLodge:
      return 'Nature Lodge';
    case UniquePropertyType.Resort:
      return 'Resort';
    case UniquePropertyType.Rv:
      return 'Rv';
    case UniquePropertyType.TinyHome:
      return 'Tiny Home';
    case UniquePropertyType.Tipi:
      return 'Tipi';
    case UniquePropertyType.Townhouse:
      return 'Townhouse';
    case UniquePropertyType.Treehouse:
      return 'Treehouse';
    case UniquePropertyType.Villa:
      return 'Villa';
    case UniquePropertyType.Windmill:
      return 'Windmill';
    case UniquePropertyType.Yurt:
      return 'Yurt';
    default:
      throw new Error('Unsupported UniquePropertyType');
  }
};

export const enumToStringSubscriptionTypes = (
  subscriptionType: SubscriptionType
): string => {
  switch (subscriptionType) {
    case SubscriptionType.Free:
      return 'Standard';
    case SubscriptionType.Bronze:
      return 'Boost';
    case SubscriptionType.Silver:
      return 'Boost Plus';
    case SubscriptionType.Gold:
      return 'Boost Max';
    default:
      throw new Error('Invalid subscription type');
  }
};
